import { render, staticRenderFns } from "./requirementEdit.vue?vue&type=template&id=24357c5c&scoped=true"
import script from "./requirementEdit.vue?vue&type=script&lang=js"
export * from "./requirementEdit.vue?vue&type=script&lang=js"
import style0 from "./requirementEdit.vue?vue&type=style&index=0&id=24357c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24357c5c",
  null
  
)

export default component.exports